import { isDarkMode } from '@localstack/services';
import { Theme } from '@mui/material';
import { grey } from '@mui/material/colors';
import { createStyles, makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => {
  const isDarkTheme = isDarkMode(theme);
  return createStyles({
    baseFontSize: {
      fontSize: 13,
    },
    ellipsisBox: {
      maxWidth: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    radioBoxActiveItem: {
      '& .Mui-checked': {
        color: isDarkTheme ? grey[500] : grey[900],
      },
    },
    hiddenAsterik: {
      display: 'none',
    },
    formControlLabelRoot: {
      marginLeft: 0,
    },
  });
});
